import { TransformEx } from "../../../LTGame/LTUtils/TransformEx";
import { P2Manager } from "../../../LTGame/Physics/P2Manager";
import LTRes from "../../../LTGame/Res/LTRes";
import GlobalUnit from "../../common/GlobalUnit";
import ResDefine from "../../common/ResDefine";
export default class ItemBase {
    constructor(trans, config, types) {
        this.config = config;
        this.types = types;
        this.ownerTrans = trans;
        this.OnInit();
    }
    OnInit() { }
    CreateModel() {
        this.rootObj = LTRes.Get(ResDefine.FixPath(this.config.model_path));
        GlobalUnit.game.level.AddItemToLevel(this.rootObj);
        TransformEx.CopyTrans(this.rootObj.transform, this.ownerTrans);
    }
    CreateBody() {
        let body = this.rootObj.getChildByName("body");
        this.body = P2Manager.instance.CreateBody(body, this.group, this.mask, p2.Body.STATIC);
        P2Manager.instance.AddBody(this.body);
        this.body["use"] = this;
    }
    BeginContact(other) {
    }
    SyncRot() {
    }
    Destroy() {
        this.rootObj.destroy();
        P2Manager.instance.RemoveBody(this.body);
        GlobalUnit.game.level.RemoveItem(this);
    }
    SyncPos() {
        P2Manager.instance.SyncTransToRigXZ(this.rootObj.transform, this.body);
    }
    FromOwnerTrans() {
        this.rootObj.transform.position = this.ownerTrans.position;
        P2Manager.instance.SyncTransToRigXZ(this.ownerTrans, this.body);
    }
    Update(dt) {
        if (this.rootObj.destroyed) {
            return;
        }
        this.OnUpdate(dt);
    }
    OnUpdate(dt) {
    }
}
